<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Assinantes</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <v-card>
          <div class="row filtros">
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de início</label>
                <date-picker
                  v-model="dataFiltro.inicio"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de inicio"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione a data de fim</label>
                <date-picker
                  v-model="dataFiltro.fim"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de fim"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Selecione um status</label>
                <select class="form-control" @change="e => statusAssinante = e.target.value" v-model="statusAssinante">
                  <option value="active">Ativo</option>
                  <option value="overdue">Atrasado</option>
                  <option value="suspended">Suspenso</option>
                  <option value="canceled">Cancelado</option>
                  <option value="error">Erro</option>
                </select>
              </div>
            </div>
            <div class="col-md-3 btns_center">
                  <button
                  class="btn_1 medium pull-right"
                  @click="filtraAssinante"
                >Filtrar</button>
            </div>
              
          </div>
            <v-card-title>Seus assinantes
            <v-spacer></v-spacer>
            <div class="exportar-botoes">
              <button
                class="btn_1"
                :disabled="assinaturasFiltradas.length === 0"
                title="Exporta as linhas exibidas na tabela"
                @click="exportar('csv')"
              ><i class="fa fa-fw fa-download"></i> Exportar CSV</button>
              <button
                class="btn_1"
                :disabled="assinaturasFiltradas.length === 0"
                title="Exporta as linhas exibidas na tabela"
                @click="exportar('txt')"
              ><i class="fa fa-fw fa-download"></i> Exportar TXT</button>
            </div>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
            
          </v-card-title>
          <v-data-table :headers="headers" :items="assinaturas" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.updated_at) }}</td>
              <td>{{ props.item.subscriber_name }}</td>
              <td>{{ props.item.plans_description }}</td>
              <td>{{ props.item.protocolo }}</td>
              <td>{{ props.item.status }}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/uniodonto/assinantes/'+props.item.protocolo"
                >
                <span class="btn_1 gray delete wishlist_close button-content">
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </span>
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { padronizaDataUS } from '../../../utils/util';
export default {
  mixins: [funcoesGerais],
  
  data() {
    const dataAtual = new Date();
    const dataAtualArray = dataAtual.toLocaleDateString().split("T")[0].split("/");
    return {
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec"
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores"
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo"
        }
      },
      search: "",
      erroMensagem: "",
      mostraErro: false,
      assinaturas: [],
      isLoading: false,
      headers: [
        { text: "Data Assinatura", value: "data_pagamento" },
        { text: "Assinante", value: "subscriber_name" },
        { text: "Plano", value: "plans_description" },
        { text: "Protocolo", value: "protocolo"},
        { text: "Status", value: "status" },
        { text: "Opções", value: "" },
      ],
      statusAssinante: "active",
      dataFiltro: {
        inicio: `01/${dataAtualArray[1]}/${dataAtualArray[2]}`,
        fim: `${dataAtualArray[0]}/${dataAtualArray[1]}/${dataAtualArray[2]}`,
      },
      pagination: { sortBy: "created_at", descending: true }
    };
  },
  computed: {
    // Mesmas linhas exibidas na tabela (considera o campo de busca "Filtrar")
    assinaturasFiltradas() {
      const termo = (this.search || "").toString().trim().toLowerCase();
      if (!termo) return this.assinaturas;
      return this.assinaturas.filter((a) =>
        [this.padronizaData(a.updated_at), a.subscriber_name, a.plans_description, a.protocolo, a.status]
          .some((valor) => (valor || "").toString().toLowerCase().includes(termo))
      );
    },
  },
  methods: {
    exportar(formato) {
      if (this.assinaturasFiltradas.length === 0) {
        alerta("warning", "Nada para exportar", "Não há assinantes na tabela com os filtros atuais.");
        return;
      }
      const cabecalho = ["Data Assinatura", "Assinante", "Plano", "Protocolo", "Status"];
      const linhas = this.assinaturasFiltradas.map((a) => [
        this.padronizaData(a.updated_at),
        a.subscriber_name,
        a.plans_description,
        a.protocolo,
        a.status,
      ]);

      let conteudo;
      let tipo;
      if (formato === "csv") {
        // ";" e BOM UTF-8 para o Excel em pt-BR abrir com acentos e colunas corretos
        const celula = (valor) => {
          let texto = valor === null || valor === undefined ? "" : String(valor);
          // evita que o Excel interprete o texto como fórmula
          if (/^[=+\-@]/.test(texto)) texto = "'" + texto;
          return '"' + texto.replace(/"/g, '""') + '"';
        };
        conteudo = "\ufeff" + [cabecalho, ...linhas].map((l) => l.map(celula).join(";")).join("\r\n");
        tipo = "text/csv;charset=utf-8;";
      } else {
        // TXT delimitado por tabulação
        const celula = (valor) =>
          (valor === null || valor === undefined ? "" : String(valor)).replace(/[\t\r\n]+/g, " ");
        conteudo = [cabecalho, ...linhas].map((l) => l.map(celula).join("\t")).join("\r\n");
        tipo = "text/plain;charset=utf-8;";
      }

      const nome = ["assinantes", this.statusAssinante, this.dataFiltro.inicio, this.dataFiltro.fim]
        .filter(Boolean)
        .join("_")
        .replace(/\//g, "-");
      const url = URL.createObjectURL(new Blob([conteudo], { type: tipo }));
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nome}.${formato}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    filtraAssinante(e){
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", "/operadoras/" + user.id_operadora + "/assinaturas/"+self.statusAssinante+"/"+inicio+"/"+fim)
        .then((response) => {
          self.isLoading = false;
          self.assinaturas = response.data;
          self.assinaturas.map((assinatura)=> {
            assinatura.status = self.padronizaStatusAssinante(assinatura.status);
          })
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    }
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      self.isLoading = true;
      let inicio = "";
      let fim = "";
      self.dataFiltro.inicio ? inicio = padronizaDataUS(self.dataFiltro.inicio) : inicio = 0;
      self.dataFiltro.fim ? fim = padronizaDataUS(self.dataFiltro.fim) : fim = 0;
      ajax("get", "/operadoras/" + user.id_operadora + "/assinaturas/"+ self.statusAssinante + "/"+ inicio + "/" + fim)
        .then((response) => {
          self.isLoading = false;
          self.assinaturas = response.data;
          self.assinaturas.map((assinatura)=> {
            assinatura.status = self.padronizaStatusAssinante(assinatura.status);
          })
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
    .filtros {
      padding: 16px;
    }
    .btns_center{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
    .exportar-botoes {
      display: flex;
      align-items: center;
      margin-right: 24px;
    }
    .exportar-botoes .btn_1 {
      padding: 9px 16px;
      font-size: 0.8125rem;
    }
    .exportar-botoes .btn_1 + .btn_1 {
      margin-left: 8px;
    }
    .exportar-botoes .btn_1:disabled {
      opacity: 0.6;
      cursor: no-drop;
    }
</style>